import styled, {css} from 'styled-components';
import { ORBIT_TAP } from '../../../../../themes/css-global-classes';
import { styledByDevice } from '../../../../../themes/architecture/styled-by-device';

interface GameImageContainerProps {
    isLoading?: boolean;
    squareIcon?: boolean;
    isCasinoGameIcon?: boolean;
}

function getPlaceholderBackground(theme, isLoading: boolean, isSquareIcon: boolean, isCasinoGameIcon: boolean): string {

    if (isLoading) return null;

    if (isCasinoGameIcon) {

        if (isSquareIcon) {
            return theme.images.singleGame.cardAndTablesSquareBackgroundImage.toString();
        }

        return theme.images.singleGame.cardAndTablesBackgroundImage.toString();
    }

    if (isSquareIcon) {
        return theme.images.singleGame.defaultSquareBackgroundImage.toString();
    }

    return theme.images.singleGame.defaultBackgroundImage.toString();
}

//.game-item-image
const DefaultBox = styled.div<GameImageContainerProps>`
    position: relative;
    width: 100%;
    overflow: hidden;
    max-width: 21rem;
    margin: auto;
    background: url(${({theme, squareIcon, isLoading, isCasinoGameIcon}) => getPlaceholderBackground(theme, isLoading, squareIcon, isCasinoGameIcon)}) no-repeat center center;
    background-size: 100%;
    ${props => props.squareIcon && css`
        border-radius: 15px;
    `};

    &::after {
        position: absolute;
        display: ${({isLoading}) => isLoading ? "block" : "none"};
        content: "";
        top: ${({squareIcon}) => squareIcon ? "0" : "1rem"};
        left: ${({squareIcon}) => squareIcon ? "0" : "1rem"};
        right: ${({squareIcon}) => squareIcon ? "0" : "1rem"};
        bottom: ${({squareIcon}) => squareIcon ? "0" : "1.5rem"};
        background: radial-gradient(rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.1));

        border-radius: ${({squareIcon}) => squareIcon ? "1.5rem" : "35%"};
        animation: LoadingAnimation 1s linear 3;
    }

    @keyframes LoadingAnimation {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
        100% {
            opacity: 1;
        }
    }
`;

export const MobileBox = styled(DefaultBox)`
    transform: none;

    &.${ORBIT_TAP} {
       transform: scale(0.95);
    }

    ${props => props.squareIcon && css`
        border-radius: 8px;
    `};
`;

export const PcBox = DefaultBox;

export const GameImageContainerDefaultBox = styledByDevice(PcBox, MobileBox);